import React, { useState, useRef } from 'react';
import { Mic, MicOff } from 'lucide-react';
import { SECTION_AGENTS } from './sectionAgentConfig';

export default function MicButton({ section, onResult, style = {} }) {
  const cfg = SECTION_AGENTS[section];
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  const toggle = () => {
    if (listening) {
      try { recRef.current?.stop(); } catch (_) {}
      setListening(false);
      return;
    }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { alert('Tu navegador no soporta reconocimiento de voz.'); return; }
    const r = new SR();
    r.lang = 'es-MX';
    r.interimResults = false;
    r.maxAlternatives = 1;
    r.onresult = e => {
      const text = e.results[0][0].transcript;
      onResult?.(text);
    };
    r.onend = () => setListening(false);
    r.onerror = () => setListening(false);
    r.start();
    recRef.current = r;
    setListening(true);
  };

  const gradClass = cfg?.color || 'from-red-500 to-rose-600';
  return (
    <button
      onClick={toggle}
      title={listening ? 'Detener grabación' : `Hablar con ${cfg?.name || 'OkBot'}`}
      className={`flex items-center justify-center rounded-full shadow-lg transition-all active:scale-95 ${
        listening
          ? 'bg-red-600 text-white animate-pulse'
          : `bg-gradient-to-br ${gradClass} text-white hover:opacity-90`
      }`}
      style={{ width: 48, height: 48, ...style }}>
      {listening ? <MicOff size={20} /> : <Mic size={20} />}
    </button>
  );
}
